var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inline-block",class:{ interactable: _vm.interactable },attrs:{"draggable":"false"},on:{"click":_vm.onClick}},[_vm._t("default"),(_vm.showIcon)?[_vm._t("addicon")]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }